import { render, staticRenderFns } from "./PromptsConfiguration.vue?vue&type=template&id=7013aea2&scoped=true"
import script from "./PromptsConfiguration.vue?vue&type=script&lang=ts"
export * from "./PromptsConfiguration.vue?vue&type=script&lang=ts"
import style0 from "./PromptsConfiguration.vue?vue&type=style&index=0&id=7013aea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7013aea2",
  null
  
)

export default component.exports